import { REDUX_KEY, TVNZ_NETWORK } from '../../constants';
import { DAY_LOWERCASE } from '../../../constants/common';
import { CampaignOptionSlice } from './types';

const initialState: CampaignOptionSlice = {
  [REDUX_KEY.PEAK_PERCENTAGE]: 0,
  [REDUX_KEY.NETWORK_BREAKDOWN_PERCENTAGE]: {
    [TVNZ_NETWORK.ONE]: 0,
    [TVNZ_NETWORK.TWO]: 0,
    [TVNZ_NETWORK.DUKE]: 0
  },
  [REDUX_KEY.DAYS]: {
    [DAY_LOWERCASE.MONDAY]: true,
    [DAY_LOWERCASE.TUESDAY]: true,
    [DAY_LOWERCASE.WEDNESDAY]: true,
    [DAY_LOWERCASE.THURSDAY]: true,
    [DAY_LOWERCASE.FRIDAY]: true,
    [DAY_LOWERCASE.SATURDAY]: true,
    [DAY_LOWERCASE.SUNDAY]: true
  },
  [REDUX_KEY.EDIT_MODE]: undefined
};

export default initialState;
